var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilityTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.8,371.6c-1.8,0-3.6-0.3-5.3-1c-40.1-16.2-66-54.9-66-98.5c0-50.8,35.4-94,83.9-104.2 C113,98.1,176.9,50.3,250,50.3c54.3,0,104.6,26.5,135.9,71.1c61.3,10.5,106.7,64.2,106.7,127.5c0,46-24.6,89-64.1,112.2 c-6.8,4-15.5,1.7-19.5-5.1c-4-6.8-1.7-15.6,5.1-19.5c30.8-18.1,50-51.6,50-87.6c0-51.1-37.9-94.2-88.1-100.1 c-4.2-0.5-8-2.9-10.3-6.4c-25.6-39.8-68.8-63.5-115.6-63.5c-63.1,0-118,43.2-133.6,105.1c-1.4,5.8-6.3,10-12.2,10.7 C65.3,199.1,36,232.3,36,272c0,32,18.9,60.3,48.2,72.1c7.3,2.9,10.8,11.3,7.9,18.6C89.8,368.2,84.4,371.6,78.8,371.6L78.8,371.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.7,335.6c-3.7,0-7.3-1.4-10.1-4.2l-47-47l-47,47c-5.6,5.6-14.6,5.6-20.2,0c-5.6-5.6-5.6-14.6,0-20.2 l57.1-57.1c5.6-5.6,14.6-5.6,20.2,0l57.1,57.1c5.6,5.6,5.6,14.6,0,20.2C243,334.2,239.4,335.6,235.7,335.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,449.7c-7.9,0-14.3-6.4-14.3-14.3V264.3c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v171.2 C192.9,443.4,186.5,449.7,178.6,449.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,449.7c-3.7,0-7.3-1.4-10.1-4.2l-57.1-57.1c-5.6-5.6-5.6-14.6,0-20.2c5.6-5.6,14.6-5.6,20.2,0l47,47 l47-47c5.6-5.6,14.6-5.6,20.2,0c5.6,5.6,5.6,14.6,0,20.2l-57.1,57.1C328.6,448.3,325,449.7,321.3,449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,449.7c-7.9,0-14.3-6.4-14.3-14.3V264.3c0-7.9,6.4-14.3,14.3-14.3c7.9,0,14.3,6.4,14.3,14.3v171.2 C335.6,443.4,329.2,449.7,321.3,449.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityTesting);
export default __webpack_public_path__ + "static/media/Mobility Testing.ce0261333b50d62ca57ceb2d276c50da.svg";
export { ForwardRef as ReactComponent };